(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gp-exploded-mower"] && !Shopify.designMode) return;
  try {
    
(()=>{
if(customElements.get('gp-mower-banner'))return;
const clamp=(v,a=0,b=1)=>Math.min(b,Math.max(a,v));
const ease=v=>{v=clamp(v);return v*v*(3-2*v)};
const pieces=[
{poly:[[0,0],[885,0],[885,310],[785,325],[785,355],[460,370],[0,370]],x:180,y:340,r:-4,s:.86},
{poly:[[885,0],[1536,0],[1536,320],[1300,330],[1130,520],[1040,630],[955,570],[850,465],[885,310]],x:-45,y:70,r:3,s:.93},
{poly:[[1536,320],[1536,700],[1345,700],[1320,645],[1125,620],[1130,520],[1300,330]],x:-235,y:-45,r:0,s:.92},
{poly:[[460,370],[785,355],[785,325],[885,310],[850,465],[790,548],[640,558],[610,445],[460,445]],x:40,y:135,r:4,s:.82},
{poly:[[0,370],[460,370],[460,445],[610,445],[640,558],[615,600],[392,596],[370,557],[0,557]],x:110,y:60,r:-6,s:.92},
{poly:[[640,558],[790,548],[850,465],[955,570],[965,630],[910,734],[875,815],[650,843],[438,790],[420,720],[505,603],[615,600]],x:25,y:65,r:0,s:.96},
{poly:[[0,557],[370,557],[392,596],[420,720],[438,790],[340,755],[0,780]],x:245,y:45,r:-8,s:.88},
{poly:[[955,570],[1040,630],[1125,620],[1320,645],[1345,700],[1536,700],[1536,810],[1190,835],[1065,810],[965,793],[910,734],[965,630]],x:-230,y:-80,r:8,s:.87},
{poly:[[0,780],[340,755],[438,790],[650,843],[575,944],[0,1024]],x:180,y:30,r:-2,s:.96},
{poly:[[650,843],[875,815],[825,898],[895,1024],[575,1024],[575,944]],x:-35,y:-160,r:5,s:.84},
{poly:[[875,815],[965,793],[1065,810],[1190,835],[1536,810],[1536,1024],[895,1024],[825,898]],x:-280,y:-50,r:-7,s:.9}
];
class MowerBanner extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  this.ready=true;this.frame=0;this.lastPainted=null;this.detailState=-1;this.playState=null;this.titleState=null;
  this.classList.add('gp-loading');this.canvas=this.querySelector('canvas');this.ctx=this.canvas.getContext('2d');this.slider=this.querySelector('input');this.play=this.querySelector('.gp-play');
  this.firstTitle=this.querySelector('.gp-title-first');this.secondTitle=this.querySelector('.gp-title-second');this.detailNo=this.querySelector('.gp-detail-no');this.detailText=this.querySelector('.gp-detail-text');this.garden=this.querySelector('.gp-garden');this.stage=this.querySelector('.gp-stage');
  this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.current=0;this.target=0;this.manual=null;this.tween=null;this.abort=new AbortController();const signal=this.abort.signal;const options={passive:true,signal};
  this.images=[new Image(),new Image()];const mobile=matchMedia('(max-width:700px)').matches;this.images[0].src=mobile?this.dataset.mowerMobile:this.dataset.mower;this.images[1].src=mobile?this.dataset.explodedMobile:this.dataset.exploded;
  Promise.all(this.images.map(i=>i.decode())).then(()=>{if(signal.aborted||!this.isConnected)return;this.classList.remove('gp-loading');this.classList.add('gp-ready');this.play.disabled=false;this.paint(this.current,true);this.measure()}).catch(()=>{if(signal.aborted||!this.isConnected)return;this.classList.remove('gp-loading');this.play.disabled=true;this.play.textContent='Preview image';});
  this.scroll=()=>{this.manual=null;this.tween=null;this.measure()};window.addEventListener('scroll',this.scroll,options);window.addEventListener('resize',()=>this.measure(),options);
  this.slider.addEventListener('input',()=>{this.tween=null;this.manual=Number(this.slider.value)/1000;this.target=this.manual;this.animate()},{signal});
  this.play.addEventListener('click',()=>this.start(this.current>.9?0:1),{signal});this.querySelector('.gp-reset').addEventListener('click',()=>this.start(0),{signal});
  this.reduced.addEventListener('change',()=>{if(this.reduced.matches&&this.tween)this.tween.duration=0;this.measure()},{signal});this.measure();
 }
 disconnectedCallback(){this.abort?.abort();cancelAnimationFrame(this.frame);this.frame=0;this.ready=false;this.tween=null}
 measure(){
  const r=this.getBoundingClientRect();
  if(this.manual===null){const distance=Math.max(1,this.offsetHeight-this.stage.offsetHeight);this.target=this.reduced.matches?0:clamp(-r.top/distance)}
  if(r.bottom<=0||r.top>=window.innerHeight){cancelAnimationFrame(this.frame);this.frame=0;this.current=this.target;return}
  if(this.lastPainted!==this.current||this.current!==this.target||this.tween)this.animate();
 }
 start(end){this.manual=end;this.target=end;this.tween={from:this.current,to:end,start:performance.now(),duration:this.reduced.matches?0:4500};this.animate()}
 animate(){
  if(this.frame||!this.isConnected||this.abort?.signal.aborted)return;
  this.frame=requestAnimationFrame(now=>{
   this.frame=0;if(!this.isConnected||this.abort?.signal.aborted)return;
   if(this.tween){const t=this.tween.duration?clamp((now-this.tween.start)/this.tween.duration):1;this.current=this.tween.from+(this.tween.to-this.tween.from)*ease(t);if(t>=1)this.tween=null}else this.current+=(this.target-this.current)*(this.reduced.matches?1:.16);
   if(Math.abs(this.target-this.current)<.0005&&!this.tween)this.current=this.target;
   this.paint(this.current);if(this.tween||Math.abs(this.target-this.current)>.0005)this.animate();
  });
 }
 paint(p,force=false){if(this.lastPainted===p&&!force)return;this.lastPainted=p;this.style.setProperty('--gp-progress',p);this.slider.value=Math.round(p*1000);const change=ease((p-.35)/.28);const first=this.firstTitle,second=this.secondTitle;first.style.opacity=1-change;first.style.transform=`translateY(${-change*18}px)`;second.style.opacity=change;second.style.transform=`translateY(${(1-change)*18}px)`;const secondVisible=change>.5;if(this.titleState!==secondVisible){this.titleState=secondVisible;first.setAttribute('aria-hidden',secondVisible);second.setAttribute('aria-hidden',!secondVisible)}const detail=p<.25?0:p<.7?1:2;if(this.detailState!==detail){this.detailState=detail;this.detailNo.textContent=['01 / 03','02 / 03','03 / 03'][detail];this.detailText.textContent=['COMPLETE BY DESIGN','ENGINEERING, REVEALED','EVERY PART HAS A PURPOSE'][detail]}this.garden.style.transform=`scale(${1.035+p*.045}) translateY(${-p*8}px)`;const reassemble=p>.9;if(this.playState!==reassemble){this.playState=reassemble;this.play.innerHTML=reassemble?'See it reassemble <span>↶</span>':'Watch it unfold <span>▷</span>';this.play.setAttribute('aria-label',reassemble?'Play mower reassembly':'Play mower disassembly')}if(!this.images.every(i=>i.complete&&i.naturalWidth))return;const c=this.ctx;c.clearRect(0,0,1536,1024);if(p>.995){c.save();c.translate(768,512);c.scale(.94,.94);c.translate(-768,-512);c.drawImage(this.images[1],0,0,1536,1024);c.restore();return}const unfold=ease((p-.08)/.82),mix=ease((p-.04)/.12);const scale=.94;const draw=(img)=>{c.drawImage(img,0,0,1536,1024)};c.save();c.translate(768,512);c.scale(scale,scale);c.translate(-768,-512);if(mix<1){c.save();c.globalAlpha=1-mix;c.translate(768,650);const z=1-unfold*.025;c.scale(z,z);c.translate(-768,-650);draw(this.images[0]);c.restore()}if(mix>0){c.save();c.globalAlpha=mix;c.beginPath();c.rect(0,0,1536,1024);for(const part of pieces){part.poly.forEach((v,i)=>i?c.lineTo(...v):c.moveTo(...v));c.closePath()}c.clip("evenodd");draw(this.images[1]);c.restore();for(const part of pieces){const cx=part.poly.reduce((a,v)=>a+v[0],0)/part.poly.length,cy=part.poly.reduce((a,v)=>a+v[1],0)/part.poly.length,remaining=1-unfold;c.save();c.globalAlpha=mix;c.translate(cx+part.x*remaining,cy+part.y*remaining);c.rotate(part.r*Math.PI/180*remaining);const s=1-(1-part.s)*remaining;c.scale(s,s);c.translate(-cx,-cy);c.beginPath();part.poly.forEach((v,i)=>i?c.lineTo(...v):c.moveTo(...v));c.closePath();c.clip();draw(this.images[1]);c.restore()}}c.restore()}
}
customElements.define('gp-mower-banner',MowerBanner);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
